import { useCallback, useEffect, useMemo, useState } from 'react';
import { attendanceApi } from 'sectors/pilates/attendance/api/attendanceApi';

export function useAttendanceQueue({ open, from, to, trainerId, q, limit = 300 }) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const res = await attendanceApi.attendanceQueue({
        from,
        to,
        trainerId,
        q,
        limit,
      });

      // http wrapper bazen {items:...} bazen direkt array döndürebilir.
      const list = Array.isArray(res) ? res : Array.isArray(res?.items) ? res.items : [];
      setItems(list);
    } catch (e) {
      setItems([]);
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [from, to, trainerId, q, limit]);

  useEffect(() => {
    if (!open) return;
    refresh();
  }, [open, refresh]);

  const count = useMemo(() => items.length, [items]);

  return { loading, items, count, error, refresh };
}
